import { api, LightningElement } from "lwc";
import {AgentblazerStatusLevel} from 'tbme/agentblazerStatus'

interface MedalConfig extends AgentblazerStatusLevel {
  class?: string;
}

export default class extends LightningElement {
  @api levels: AgentblazerStatusLevel[] = []
  medals: MedalConfig[] = [];
  displayText: string = ""
  medalStackClass: string = ""
  levelClass: string = ""

  connectedCallback() {
    let levels = [...this.levels]
    levels.sort((a, b) => (
      a.level - b.level
    ))

    this.levelClass = `level-status level-status-${levels.length}`
    this.medalStackClass = `medal-stack-${levels.length}`

    this.medals = levels.map((level, i) => {
      const medalNumber = i + 1;

      if (medalNumber === levels.length && level.displayText) {
        this.displayText = level.displayText
      }

      return {
        ...level,
        class: `medal medal--level-${medalNumber}`
      }
    })
  }
}
